import i18n from '../i18n';

export const getSoundPresetDescription = (id) => i18n.t(`shared:soundPresets.${id}`);

const createContext = () => {
  const AudioContext = window?.AudioContext || window?.webkitAudioContext;
  if (!AudioContext) {
    return null;
  }
  return new AudioContext();
};

export const SOUND_PRESETS = [
  {
    id: 'bamboo',
    name: 'Bamboo',
    file: 'sounds/Bamboo.mp3',
    isPlus: false,
    pattern: [
      { type: 'sine', frequency: 660, duration: 0.28, gain: 0.25, attack: 0.02, release: 0.15, delay: 0 },
      { type: 'sine', frequency: 990, duration: 0.22, gain: 0.18, attack: 0.02, release: 0.12, delay: 0.18 },
    ],
  },
  {
    id: 'bubble',
    name: 'Bubble',
    file: 'sounds/Bubble.mp3',
    isPlus: false,
    pattern: [
      { type: 'triangle', frequency: 880, duration: 0.25, gain: 0.3, attack: 0.01, release: 0.18, delay: 0 },
      { type: 'triangle', frequency: 1175, duration: 0.25, gain: 0.22, attack: 0.01, release: 0.2, delay: 0.22 },
    ],
  },
  {
    id: 'bumble-2',
    name: 'Bumble 2',
    file: 'sounds/Bumble 2.mp3',
    isPlus: false,
    pattern: [
      { type: 'square', frequency: 1200, duration: 0.18, gain: 0.28, attack: 0.005, release: 0.1, delay: 0 },
      { type: 'square', frequency: 1200, duration: 0.18, gain: 0.28, attack: 0.005, release: 0.1, delay: 0.22 },
    ],
  },
  {
    id: 'jungle',
    name: 'Jungle',
    file: 'sounds/Jungle.mp3',
    isPlus: false,
    pattern: [
      { type: 'sine', frequency: 520, duration: 0.35, gain: 0.24, attack: 0.02, release: 0.2, delay: 0 },
      { type: 'sine', frequency: 680, duration: 0.35, gain: 0.2, attack: 0.02, release: 0.2, delay: 0.32 },
    ],
  },
  {
    id: 'new-day',
    name: 'New Day',
    file: 'sounds/New Day.mp3',
    isPlus: false,
    pattern: [
      { type: 'sawtooth', frequency: 740, endFrequency: 980, duration: 0.4, gain: 0.22, attack: 0.015, release: 0.18, delay: 0 },
      { type: 'sine', frequency: 1240, duration: 0.2, gain: 0.18, attack: 0.01, release: 0.12, delay: 0.38 },
    ],
  },
  {
    id: 'victory',
    name: 'Victory',
    file: 'sounds/Victory.mp3',
    isPlus: false,
    pattern: [
      { type: 'sine', frequency: 600, duration: 0.3, gain: 0.26, attack: 0.015, release: 0.16, delay: 0 },
      { type: 'triangle', frequency: 950, duration: 0.26, gain: 0.2, attack: 0.012, release: 0.14, delay: 0.24 },
      { type: 'square', frequency: 1250, duration: 0.22, gain: 0.16, attack: 0.01, release: 0.12, delay: 0.46 },
    ],
  },
];

// Plus Ses Paketi - Sadece Plus kullanıcıları için
export const PLUS_SOUND_PRESETS = [
  {
    id: 'plus-royal',
    name: 'Plus Royal',
    file: 'sounds/Plus Royal.mp3',
    isPlus: true,
    pattern: [
      { type: 'sine', frequency: 800, duration: 0.3, gain: 0.28, attack: 0.02, release: 0.18, delay: 0 },
      { type: 'triangle', frequency: 1000, duration: 0.25, gain: 0.22, attack: 0.015, release: 0.15, delay: 0.25 },
      { type: 'sine', frequency: 1200, duration: 0.2, gain: 0.18, attack: 0.01, release: 0.12, delay: 0.45 },
    ],
  },
  {
    id: 'plus-luxury',
    name: 'Plus Luxury',
    file: 'sounds/Plus Luxury.mp3',
    isPlus: true,
    pattern: [
      { type: 'triangle', frequency: 900, duration: 0.32, gain: 0.26, attack: 0.018, release: 0.2, delay: 0 },
      { type: 'sine', frequency: 1100, duration: 0.28, gain: 0.24, attack: 0.015, release: 0.16, delay: 0.28 },
    ],
  },
  {
    id: 'plus-exclusive',
    name: 'Plus Exclusive',
    file: 'sounds/Plus Exclusive.mp3',
    isPlus: true,
    pattern: [
      { type: 'sawtooth', frequency: 750, endFrequency: 1050, duration: 0.35, gain: 0.27, attack: 0.02, release: 0.19, delay: 0 },
      { type: 'triangle', frequency: 1150, duration: 0.26, gain: 0.23, attack: 0.016, release: 0.17, delay: 0.32 },
      { type: 'sine', frequency: 1300, duration: 0.22, gain: 0.19, attack: 0.012, release: 0.14, delay: 0.52 },
    ],
  },
];

export const DEFAULT_SOUND_ID = SOUND_PRESETS[0]?.id || 'bamboo';

const resolveAssetUrl = async (fileReference) => {
  if (!fileReference) {
    return null;
  }

  const toSegments = (reference) => {
    if (Array.isArray(reference)) {
      return reference;
    }
    if (typeof reference === 'string') {
      return reference.split('/').filter(Boolean);
    }
    return [];
  };

  const segments = toSegments(fileReference);

  if (typeof window !== 'undefined' && window.api?.getAssetUrl) {
    try {
      const url = await window.api.getAssetUrl(segments);
      if (url) {
        return url;
      }
    } catch (error) {
      console.warn("Varlık URL'si alınamadı:", error);
    }
  }

  const joined = segments.join('/');
  if (!joined) {
    return null;
  }

  if (/^https?:\/\//i.test(joined) || joined.startsWith('file://')) {
    return joined;
  }

  const base = (typeof process !== 'undefined' && process?.env?.PUBLIC_URL) || '';
  const normalizedBase = base ? base.replace(/\/+$/, '') : '';
  const encodedPath = joined
    .split('/')
    .map((segment) => encodeURIComponent(segment))
    .join('/');

  if (normalizedBase) {
    return `${normalizedBase}/assets/${encodedPath}`;
  }
  return `assets/${encodedPath}`;
};

const playPatternSound = (preset) => {
  if (typeof window === 'undefined') {
    return Promise.resolve();
  }

  const context = createContext();
  if (!context) {
    return Promise.resolve();
  }

  const cleanupTimeouts = [];

  const scheduleOscillator = (step) => {
    const oscillator = context.createOscillator();
    const gain = context.createGain();
    const now = context.currentTime;

    const delay = step.delay || 0;
    const duration = step.duration || 0.3;
    const attack = step.attack ?? 0.01;
    const release = step.release ?? 0.12;
    const startTime = now + delay;
    const stopTime = startTime + duration;

    oscillator.type = step.type || 'sine';
    oscillator.frequency.setValueAtTime(step.frequency || 440, startTime);
    if (step.endFrequency && typeof step.endFrequency === 'number') {
      oscillator.frequency.exponentialRampToValueAtTime(step.endFrequency, stopTime);
    }

    gain.gain.setValueAtTime(0.0001, startTime);
    gain.gain.exponentialRampToValueAtTime(step.gain ?? 0.2, startTime + attack);
    gain.gain.exponentialRampToValueAtTime(0.0001, stopTime + release);

    oscillator.connect(gain);
    gain.connect(context.destination);

    oscillator.start(startTime);
    oscillator.stop(stopTime + release);

    const clearId = window.setTimeout(() => {
      gain.disconnect?.();
      oscillator.disconnect?.();
    }, Math.max((stopTime + release - now) * 1000, 0));
    cleanupTimeouts.push(clearId);
  };

  return new Promise((resolve, reject) => {
    const finalize = () => {
      cleanupTimeouts.forEach((id) => window.clearTimeout(id));
      try {
        context.close?.();
      } catch (error) {
        // ignore close errors
      }
      resolve();
    };

    try {
      (preset.pattern || []).forEach(scheduleOscillator);
      const durations = (preset.pattern || []).map(
        (step) => (step.delay || 0) + (step.duration || 0.3) + (step.release || 0.12),
      );
      const totalDuration = (durations.length ? Math.max(...durations) : 0.5) + 0.2;

      window.setTimeout(finalize, totalDuration * 1000);
    } catch (error) {
      cleanupTimeouts.forEach((id) => window.clearTimeout(id));
      try {
        context.close?.();
      } catch (closeError) {
        console.warn('AudioContext kapatılamadı:', closeError);
      }
      reject(error);
    }
  });
};

const playFileSound = async (preset) =>
  new Promise(async (resolve, reject) => {
    if (typeof window === 'undefined' || typeof Audio === 'undefined') {
      resolve();
      return;
    }

    let audio = null;
    let timeoutId = null;

    const cleanup = () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
        timeoutId = null;
      }
      if (audio) {
        audio.removeEventListener('ended', handleEnded);
        audio.removeEventListener('error', handleError);
      }
    };

    const handleEnded = () => {
      cleanup();
      resolve();
    };

    const handleError = (event) => {
      cleanup();
      reject(event?.error || new Error('Ses dosyası oynatılamadı'));
    };

    try {
      const src = await resolveAssetUrl(preset.file);
      if (!src) {
        throw new Error('Ses dosyasının yolu bulunamadı.');
      }

      audio = new Audio(src);
      if (typeof preset.volume === 'number') {
        audio.volume = Math.min(Math.max(preset.volume, 0), 1);
      }

      audio.addEventListener('ended', handleEnded);
      audio.addEventListener('error', handleError);

      const playResult = audio.play();
      if (playResult && typeof playResult.then === 'function') {
        playResult.catch((error) => {
          cleanup();
          reject(error);
        });
      }

      const maxDuration = Math.max(preset.maxDuration || 15, 1);
      timeoutId = window.setTimeout(() => {
        cleanup();
        resolve();
      }, maxDuration * 1000);
    } catch (error) {
      cleanup();
      reject(error);
    }
  });

export const playPresetSound = (soundId) => {
  if (typeof window === 'undefined') {
    return Promise.resolve();
  }

  // Check regular presets first
  let preset = SOUND_PRESETS.find((item) => item.id === soundId);
  // If not found, check Plus presets
  if (!preset) {
    preset = PLUS_SOUND_PRESETS.find((item) => item.id === soundId);
  }
  // Fallback to first regular preset
  if (!preset) {
    preset = SOUND_PRESETS[0];
  }
  if (!preset) {
    return Promise.resolve();
  }

  if (preset.file) {
    return playFileSound(preset).catch((error) => {
      console.warn(
        `Ses dosyası çalınırken sorun oluştu (${preset.file}). Sentetik sese düşülüyor:`,
        error,
      );
      if (preset.pattern) {
        return playPatternSound(preset);
      }
      return undefined;
    });
  }

  if (preset.pattern) {
    return playPatternSound(preset);
  }

  return Promise.resolve();
};